module.exports = __webpack_public_path__ + "img/placeholder.de1c5810.png";